import { Box } from '@mui/material';

import { Filter } from '@/components';
import { CreditType } from '@/types';

import { SearchBar } from './SearchBar';

export const Filters = ({
  selectedFilter,
  setSelectedFilter,
  setSearchTerm,
}: {
  selectedFilter: CreditType | 'all';
  setSelectedFilter: (filter: CreditType | 'all') => void;
  setSearchTerm: (term: string) => void;
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 2,
        flexWrap: 'wrap',
        width: '100%',
        mr: 4,
      }}>
      <Box>
        <Filter
          options={[
            {
              type: 'radio',
              label: 'Source',
              values: ['All Sources', 'LumiQ', 'External'],
            },
          ]}
          selectedOptions={[
            selectedFilter === 'all'
              ? 'All Sources'
              : selectedFilter === 'lumiq'
                ? 'LumiQ'
                : 'External',
          ]}
          onFilterChange={values => {
            setSelectedFilter(
              values[0] === 'All Sources'
                ? 'all'
                : values[0] === 'LumiQ'
                  ? 'lumiq'
                  : 'custom',
            );
          }}
        />
      </Box>
      <Box
        sx={{
          height: 45,
          display: 'flex',
          alignItems: 'center',
          flexGrow: 1,
        }}>
        <SearchBar setSearchTerm={setSearchTerm} />
      </Box>
    </Box>
  );
};
